
// src/reducers/saved-diaries-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'

import { 
  SAVE_DIARY,
  SAVE_DIARY_REQUESTED,
  SAVE_DIARY_COMPLETED,
  SAVE_DIARY_FAILED,
  CLEAR_SAVED_DIARY,
  FETCH_SAVED_DIARIES,
  FETCH_SAVED_DIARIES_REQUESTED,
  FETCH_SAVED_DIARIES_COMPLETED,
  FETCH_SAVED_DIARIES_FAILED,
  DELETE_SAVED_DIARY,
  DELETE_SAVED_DIARY_REQUESTED,
  DELETE_SAVED_DIARY_COMPLETED,
  DELETE_SAVED_DIARY_FAILED,
  CLEAR_SAVED_DIARIES,
  DELETE_ALL_SAVED_DIARY,
  DELETE_ALL_SAVED_DIARY_REQUESTED,
  DELETE_ALL_SAVED_DIARY_COMPLETED,
  DELETE_ALL_SAVED_DIARY_FAILED
} from '../actions/saved-diaries'

import {
  EDIT_DIARY,
  EDIT_DIARY_REQUESTED,
  EDIT_DIARY_COMPLETED,
  EDIT_DIARY_FAILED,
} from '../actions/edit-diary'

import {
  POST_OR_UPDATE_DIARY_COMPLETED
} from '../actions/diaries'

const initialState = {
  isFetching: false,
  isPosting: false,
  isPostFailed: false,
  items: undefined,
  current: undefined,
}

export default function savedDiariesReducer(state = initialState, action = {}) {
  switch(action.type) {
  case SAVE_DIARY_REQUESTED:
    return Object.assign({}, state, {
      isPosting: true,
      isPostFailed: false,
    })

  case SAVE_DIARY_COMPLETED:
    if (!state.isPosting)
      return state

    return Object.assign({}, state, {
      isPosting: false,
      isPostFailed: false,
      items: mergeArray('diary_id', state.items, [action.results]),
      current: action.results
    })

  case CLEAR_SAVED_DIARY:
    return Object.assign({}, state, {
      isPosting: false,
      current: undefined,
    })

  case SAVE_DIARY_FAILED:
    return Object.assign({}, state, {
      isPosting: false,
      isPostFailed: true,
    })

  case FETCH_SAVED_DIARIES_REQUESTED:
  case DELETE_SAVED_DIARY_REQUESTED:
  case DELETE_ALL_SAVED_DIARY_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
    })

  case FETCH_SAVED_DIARIES_FAILED:
  case DELETE_SAVED_DIARY_FAILED:
  case DELETE_ALL_SAVED_DIARY_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case FETCH_SAVED_DIARIES_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: action.results,
    })

  case DELETE_SAVED_DIARY_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: deleteArray('diary_id', state.items, action.results.diary_id),
      current: state.current && state.current.diary_id == action.results.diary_id ? undefined : state.current
    })

  case DELETE_ALL_SAVED_DIARY_COMPLETED: 
    return Object.assign({}, state, {
      isFetching: false,
      items: [],
      current: state.current && state.current.diary_id == action.results.diary_id ? undefined : state.current
    })
  case POST_OR_UPDATE_DIARY_COMPLETED:
    return Object.assign({}, state, {
      current: undefined,
    })

  case EDIT_DIARY_COMPLETED:
    if (!state.current)
      return Object.assign({}, state, {
        current: action.results,
      })
    else
      return state

  case CLEAR_SAVED_DIARIES:
    return initialState

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/saved-diaries-reducer.js